import { useContext, useEffect, useState } from "react";
import "../../Announcement/Announcement.scss";
import { toast } from "react-toastify";
import { confirmDialog } from "primereact/confirmdialog";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import {
  inputStyles,
  labelStyles,
  styles,
} from "../../Announcement/AnnouncementStyles";
import InputBox from "../../../../components/Fields/Input Box/InputBox";
import { AppContext } from "../../../../context/AppContext";
import api from "../../../../api.js";
import Loader from "../../../../components/Loader/Loader.jsx";

const Academic_Calendar_Page = () => {
  const { backendUrl } = useContext(AppContext);
  const [allAcademicCalendar, setAllAcademicCalendar] = useState([]);
  const [academicCalendar, setAcademicCalendar] = useState({
    filename: "",
    document: null,
  });
  const [selectedAcademicCalendar, setSelectedAcademicCalendar] =
    useState(null);
  const [updatedAcademicCalendar, setUpdatedAcademicCalendar] = useState({});
  const [visible, setVisible] = useState(false);
  const [validationError, setValidationError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [scrollHeight, setScrollHeight] = useState("425px");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formErrors, setFormErrors] = useState({
    filename: null,
    document: null,
  });
  let errorShown = false;

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerHeight;
      if (screenWidth >= 900) {
        setScrollHeight("650px");
      } else {
        setScrollHeight("440px");
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  async function fetchAllAcademicCalendar() {
    setLoading(true);
    try {
      const { data } = await api.get(
        `${backendUrl}/api/auth/getAllAcademicCalendar`
      );
      if (data.success) {
        setAllAcademicCalendar(data || []);
      }
      errorShown = false;
    } catch (error) {
      if (errorShown) return;
      errorShown = true;
      if (!navigator.onLine) {
        toast.error("🚫 No internet connection. Please check your network.");
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.request && !error.response) {
        toast.error(
          "⚠️ Network issue or server is unreachable. Try again later."
        );
      } else if (error.response && error.response.status === 400) {
        toast.error(error.response.data.message);
      } else if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchAllAcademicCalendar();
  }, []);

  const validateFormFields = (filename, file, isEditMode = false) => {
    const errors = {
      filename: null,
      document: null,
    };
    const sanitizedFilename = filename?.trim();
    if (!isEditMode && !sanitizedFilename) {
      errors.filename = "Please enter a filename";
    }
    if (!isEditMode && !file) {
      errors.document = "Please select a file to upload";
    }
    const isFilenameMissing = !filename || filename.trim() === "";
    if (isEditMode && isFilenameMissing) {
      errors.filename = "Please provide a new filename or select a new file";
      return errors;
    }
    if (!isFilenameMissing) {
      errors.filename = null;
    }
    if (file) {
      const allowedTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      if (!allowedTypes.includes(file.type)) {
        errors.document =
          "Only PDF, DOC, DOCX, XLS, and XLSX files are allowed";
      }
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        errors.document = "File size must be less than 10MB";
      }
    }
    return errors;
  };

  async function uploadAcademicCalendar(e) {
    e.preventDefault();
    const errors = validateFormFields(
      academicCalendar.filename,
      academicCalendar.document
    );
    setFormErrors(errors);
    if (errors.filename || errors.document) {
      return;
    }
    setIsSubmitting(true);
    if (!academicCalendar.document) {
      toast.error("Please select a file to upload");
      return;
    }
    const formData = new FormData();
    formData.append("document", academicCalendar.document);
    formData.append("filename", academicCalendar.filename);
    try {
      const { data } = await api.post(
        `${backendUrl}/api/auth/uploadAcademicCalendar`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (data.success) {
        toast.success(data.message);
        fetchAllAcademicCalendar();
        setAcademicCalendar({
          filename: "",
          document: null,
        });
        setVisible(false);
        setFormErrors({ filename: null, document: null });
      }
      errorShown = false;
    } catch (error) {
      if (errorShown) return;
      errorShown = true;
      if (!navigator.onLine) {
        toast.error("🚫 No internet connection. Please check your network.");
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.request && !error.response) {
        toast.error(
          "⚠️ Network issue or server is unreachable. Try again later."
        );
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  const showConfirmDialog = (rowData) => {
    confirmDialog({
      message: (
        <div className="custom-dialog-content">
          <div className="iconParent">
            <i className="pi pi-times"></i>
          </div>
          <div className="contentParent">
            <h2>Are you sure?</h2>
            <p>Do you really want to delete this best practices?</p>
            <p>This process cannot be undone.</p>
          </div>
        </div>
      ),
      header: "",
      icon: null,
      acceptLabel: "Delete",
      rejectLabel: "Cancel",
      acceptClassName: "p-button-danger custom-delete-btn",
      rejectClassName: "p-button-secondary custom-cancel-btn",
      accept: () => handleDeleteClick(rowData),
    });
  };

  async function handleDeleteClick(rowData) {
    try {
      const { data } = await api.delete(
        `${backendUrl}/api/auth/deleteAcademicCalendar/${rowData.id}`
      );
      if (data.success) {
        toast.success(data.message);
        fetchAllAcademicCalendar();
      }
      errorShown = false;
    } catch (error) {
      if (errorShown) return;
      errorShown = true;
      if (!navigator.onLine) {
        toast.error("🚫 No internet connection. Please check your network.");
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.request && !error.response) {
        toast.error(
          "⚠️ Network issue or server is unreachable. Try again later."
        );
      } else {
        toast.error("Something went wrong.");
      }
    }
  }

  const handleEditClick = (rowData) => {
    setSelectedAcademicCalendar(rowData);
    setUpdatedAcademicCalendar({
      filename: rowData.filename,
      description: rowData.description,
      file: null,
    });
    setVisible(true);
  };

  const updateAcademicCalendar = async (e) => {
    e.preventDefault();
    const { filename, file } = updatedAcademicCalendar;
    const errors = validateFormFields(filename, file, true);
    setFormErrors(errors);
    if (errors.filename || errors.document) {
      return;
    }
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      if (updatedAcademicCalendar.file) {
        formData.append("document", updatedAcademicCalendar.file);
      }
      if (updatedAcademicCalendar.filename) {
        formData.append("filename", updatedAcademicCalendar.filename);
      }
      const { data } = await api.put(
        `${backendUrl}/api/auth/updateAcademicCalendar/${selectedAcademicCalendar.id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (data.success) {
        toast.success(data.message);
        fetchAllAcademicCalendar();
        setVisible(false);
        setSelectedAcademicCalendar(null);
        setUpdatedAcademicCalendar({});
        setValidationError(null);
      }
      errorShown = false;
    } catch (error) {
      if (errorShown) return;
      errorShown = true;
      if (!navigator.onLine) {
        toast.error("🚫 No internet connection. Please check your network.");
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.request && !error.response) {
        toast.error(
          "⚠️ Network issue or server is unreachable. Try again later."
        );
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleStatus = async (rowData) => {
    const id = rowData.id;
    const newStatus = !rowData.isActive;
    setIsSubmitting(true);
    try {
      const { data } = await api.patch(
        `${backendUrl}/api/auth/toggleAcademicCalendarReportStatus/${id}`,
        { isActive: newStatus }
      );
      if (data.success) {
        toast.success(data.message);
      }
      fetchAllAcademicCalendar();
      errorShown = false;
    } catch (error) {
      if (errorShown) return;
      errorShown = true;
      if (!navigator.onLine) {
        toast.error("🚫 No internet connection. Please check your network.");
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.request && !error.response) {
        toast.error(
          "⚠️ Network issue or server is unreachable. Try again later."
        );
      } else if (error.response && error.response.status === 404) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="adminAuditReportsMainContainer">
      <Loader visible={isSubmitting} />

      <div className="headerParent">
        <h2>Welcome to Admin Academic Calendar Page</h2>
      </div>

      <Dialog
        header={
          selectedAcademicCalendar
            ? "Edit Academic Calendar"
            : "Upload Academic Calendar"
        }
        visible={visible}
        style={{ width: "40vw" }}
        onHide={() => {
          setVisible(false);
          setSelectedAcademicCalendar(null);
          setAcademicCalendar({});
          setUpdatedAcademicCalendar({});
          setFormErrors({ filename: null, document: null });
          setIsSubmitting(false);
        }}
        draggable={false}
        resizable={false}
        modal
        className="customAnnouncementDialog"
      >
        <form
          onSubmit={
            selectedAcademicCalendar
              ? updateAcademicCalendar
              : uploadAcademicCalendar
          }
        >
          <InputBox
            styles={styles}
            inputStyles={inputStyles}
            labelStyles={labelStyles}
            fieldName="filename"
            customLabelName="File Name"
            required={!selectedAcademicCalendar}
            placeholder="Enter a display name for this file (visible to users)"
            value={
              selectedAcademicCalendar
                ? updatedAcademicCalendar.filename || ""
                : academicCalendar.filename || ""
            }
            handleChange={(e) => {
              const val = e.target.value;
              setFormErrors((prev) => ({ ...prev, filename: null }));
              selectedAcademicCalendar
                ? setUpdatedAcademicCalendar((prev) => ({
                    ...prev,
                    filename: val,
                  }))
                : setAcademicCalendar((prev) => ({ ...prev, filename: val }));
            }}
          />
          {formErrors.filename && (
            <div className="validation-error">
              <i className="pi pi-exclamation-triangle"></i>
              {formErrors.filename}
            </div>
          )}
          <div className="inputFieldWrapper">
            <label style={labelStyles}>
              Upload New File{" "}
              {!selectedAcademicCalendar && (
                <sup
                  style={{
                    fontWeight: "700",
                    color: "red",
                    fontSize: "1.3rem",
                  }}
                >
                  *
                </sup>
              )}
            </label>
            {selectedAcademicCalendar && (
              <div
                style={{
                  margin: "8px 0px",
                  fontFamily: "var(--font-paragraph)",
                  fontSize: "var(--paragraph-font-size)",
                }}
              >
                Current file: {selectedAcademicCalendar.filename}
              </div>
            )}
            <input
              type="file"
              accept=".pdf,.doc,.docx,.xls,.xlsx"
              style={inputStyles}
              name="document"
              onChange={(e) => {
                const file = e.target.files[0];
                setFormErrors((prev) => ({ ...prev, document: null }));
                setValidationError(null);
                selectedAcademicCalendar
                  ? setUpdatedAcademicCalendar((prev) => ({
                      ...prev,
                      file,
                      filename: file.name,
                    }))
                  : setAcademicCalendar((prev) => ({
                      ...prev,
                      document: file,
                    }));
              }}
            />
            {formErrors.document && (
              <div className="validation-error">
                <i className="pi pi-exclamation-triangle"></i>
                {formErrors.document}
              </div>
            )}
          </div>
          <div className="submitBtnParent">
            <button
              type="submit"
              className="submitButton"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <i className="pi pi-spinner pi-spin"></i> Processing...
                </>
              ) : selectedAcademicCalendar ? (
                "Update Report"
              ) : (
                "Upload Report"
              )}
            </button>
          </div>
        </form>
      </Dialog>

      <div className="uploadBtnsParent">
        <Button
          label="Upload Academic Calendar"
          onClick={() => setVisible(true)}
          className="uploadBtn"
        />
      </div>

      <article className="tableWrapper">
        <div className="scrollableTableContainer">
          <DataTable
            value={allAcademicCalendar.reports}
            showGridlines
            stripedRows
            className="table"
            emptyMessage="No Academic Calendar available"
            paginator
            rows={5}
            rowsPerPageOptions={[5, 10, 20]}
            scrollable
            scrollHeight={scrollHeight}
            loading={loading}
          >
            <Column
              header="S.No"
              body={(_, options) => options.rowIndex + 1}
              className="tableData"
              headerStyle={{ whiteSpace: "nowrap" }}
              bodyStyle={{ whiteSpace: "nowrap" }}
            />
            <Column
              field="filename"
              header="Name"
              className="tableData"
              style={{ minWidth: "300px", maxWidth: "325px" }}
              bodyStyle={{ whiteSpace: "normal" }}
            />
            <Column
              header="Report"
              className="tableData"
              style={{ minWidth: "325px", maxWidth: "325px" }}
              bodyStyle={{ whiteSpace: "normal" }}
              body={(rowData) => {
                const report = rowData;
                if (!report.data || !report.filename || !report.contentType) {
                  return <span>No Academic Calendar</span>;
                }
                const byteCharacters = atob(report.data);
                const byteNumbers = Array.from(byteCharacters).map((char) =>
                  char.charCodeAt(0)
                );
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {
                  type: report.contentType,
                });
                const downloadUrl = URL.createObjectURL(blob);
                return (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <span style={{ whiteSpace: "normal", width: "100%" }}>
                      {report.filename}
                    </span>
                    <a
                      href={downloadUrl}
                      download={report.filename}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-pr-tooltip="Download file"
                      data-pr-position="top"
                      style={{ marginLeft: "10px" }}
                    >
                      <Button
                        icon="pi pi-download"
                        rounded
                        text
                        severity="info"
                        aria-label="Download"
                        className="download-button"
                      />
                    </a>
                  </div>
                );
              }}
            />
            <Column
              field="createdAt"
              header="Created At"
              headerStyle={{ whiteSpace: "nowrap" }}
              bodyStyle={{ whiteSpace: "nowrap" }}
              body={(rowData) =>
                new Date(rowData.createdAt).toLocaleDateString()
              }
              className="tableData"
            />
            <Column
              field="updatedAt"
              header="Updated At"
              headerStyle={{ whiteSpace: "nowrap" }}
              bodyStyle={{ whiteSpace: "nowrap" }}
              body={(rowData) =>
                new Date(rowData.updatedAt).toLocaleDateString()
              }
              className="tableData"
            />
            <Column
              field="status"
              header="Status"
              className="tableData"
              headerStyle={{ whiteSpace: "nowrap" }}
              bodyStyle={{ whiteSpace: "nowrap" }}
              body={(rowData) => (
                <div className="statusBtnParent">
                  <Button
                    label={rowData.isActive ? "Active" : "Deactive"}
                    severity={rowData.isActive ? "success" : "danger"}
                    className="statusBtn"
                    onClick={() => toggleStatus(rowData)}
                  />
                </div>
              )}
            />
            <Column
              header="Action"
              headerStyle={{ whiteSpace: "nowrap" }}
              bodyStyle={{ whiteSpace: "nowrap" }}
              body={(rowData) => (
                <div className="action-buttons">
                  <Button
                    label="Edit"
                    severity="success"
                    className="actionBtns"
                    onClick={() => handleEditClick(rowData)}
                  />
                  <Button
                    label="Delete"
                    severity="danger"
                    className="actionBtns"
                    onClick={() => showConfirmDialog(rowData)}
                  />
                </div>
              )}
              className="tableData"
            />
          </DataTable>
        </div>
      </article>
    </div>
  );
};

export default Academic_Calendar_Page;
